const selectString = (boolValue, ifTrue, ifFalse) => (boolValue
  ? ifTrue
  : ifFalse);

export default selectString;
